import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuService } from 'src/app/shared/services/menu.service';
import { environment } from 'src/environments/environment';
import { menuItems } from 'src/environments/environment.base';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit {

  @ViewChild('menuToggle', { static: false }) menuToggle!: ElementRef;

  menuItems = menuItems.filter(item => item.boolean);
  imageMenu: string = environment.imageStation;

  constructor(
    private router: Router,
    private _menuService: MenuService,
  ) { }

  ngOnInit(): void {    
  }

  ngAfterViewInit(): void {
    this._menuService.setMenuToggle(this.menuToggle.nativeElement);
  }

  goToHome() {
    this.router.navigate(['home']);
    this.closeMenu();
  }

  goToNews() {
    this.router.navigate(['news']);
    this.closeMenu();
  }

  closeMenu() {
    this._menuService.closeMenu();
  }

}
